const defaultOrnamentationOffsets = {
  top: '64px',
  right: '-74px',
  bottom: '0px', // units required for calc() to work
  left: '-95px',
};

export function getOrnamentationOffsetsCss(ornamentationOffsets) {
  return Object.entries({
    ...defaultOrnamentationOffsets,
    ...ornamentationOffsets,
  }).reduce((acc, [side, value]) => {
    if (value != null) {
      acc[`--ornament-${side}`] = value;
    }
    return acc;
  }, {});
}
